// extracted by mini-css-extract-plugin
module.exports = {"input":"Aside_input__SALrD","item":"Aside_item__QXsdd","imageGray":"Aside_imageGray__ZM0da","chatIcon":"Aside_chatIcon__UPt2r"};